export const AtlassianBlogLogoInverse = () => (
  <svg
    width="386"
    height="48"
    viewBox="0 0 386 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_815_1117)">
      <path
        d="M10.3 19.2001C9.8 18.6001 9 18.7001 8.6 19.4001L0.0999985 36.4001C-0.200001 37.0001 0.299999 37.8001 0.999999 37.8001H12.8C13.2 37.8001 13.5 37.6001 13.7 37.2001C16.3 32.0001 14.7 24.0001 10.3 19.2001Z"
        fill="url(#paint0_linear_815_1117)"
      />
      <path
        d="M16.5 3.8002C11.8 11.3002 12.1 19.6002 15.2 25.9002C18.3 32.2002 20.7 36.9002 20.9 37.3002C21.1 37.7002 21.4 37.9002 21.8 37.9002H33.6C34.4 37.9002 34.8 37.1002 34.5 36.4002C34.5 36.4002 18.6 4.6002 18.2 3.8002C17.9 3.0002 16.9 3.0002 16.5 3.8002Z"
        fill="white"
      />
      <path
        d="M155 17.4001C155 21.6001 156.9 24.9001 164.6 26.4001C169.1 27.4001 170.1 28.1001 170.1 29.6001C170.1 31.1001 169.1 32.0001 165.9 32.0001C162.2 32.0001 157.8 30.7001 154.9 29.0001V35.8001C157.2 36.9001 160.2 38.2001 165.9 38.2001C173.9 38.2001 177 34.6001 177 29.4001M177 29.4001C177 24.4001 174.4 22.1001 166.9 20.5001C162.8 19.6001 161.8 18.7001 161.8 17.4001C161.8 15.8001 163.3 15.1001 166 15.1001C169.3 15.1001 172.5 16.1001 175.6 17.5001V11.0001C173.4 9.9001 170.1 9.1001 166.2 9.1001C158.8 9.1001 155 12.3001 155 17.5001"
        fill="white"
      />
      <path
        d="M257.4 9.30029V37.8003H263.5V16.1003L266 21.9003L274.6 37.8003H282.2V9.30029H276.2V27.7003L273.9 22.4003L267 9.30029H257.4Z"
        fill="white"
      />
      <path d="M218.8 9.30029H212.2V37.8003H218.8V9.30029Z" fill="white" />
      <path
        d="M204.6 29.4001C204.6 24.4001 202 22.1001 194.5 20.5001C190.4 19.6001 189.4 18.7001 189.4 17.4001C189.4 15.8001 190.9 15.1001 193.6 15.1001C196.9 15.1001 200.1 16.1001 203.2 17.5001V11.0001C201 9.9001 197.7 9.1001 193.8 9.1001C186.4 9.1001 182.6 12.3001 182.6 17.5001C182.6 21.7001 184.5 25.0001 192.2 26.5001C196.7 27.5001 197.7 28.2001 197.7 29.7001C197.7 31.2001 196.7 32.1001 193.5 32.1001C189.8 32.1001 185.4 30.8001 182.5 29.1001V35.9001C184.8 37.0001 187.8 38.3001 193.5 38.3001C201.4 38.2001 204.6 34.7001 204.6 29.4001Z"
        fill="white"
      />
      <path
        d="M103.6 9.30029V37.8003H117.2L119.3 31.7003H110.2V9.30029H103.6Z"
        fill="white"
      />
      <path
        d="M76.7 9.30029V15.5003H84V37.8003H90.7V15.5003H98.6V9.30029H76.7Z"
        fill="white"
      />
      <path
        d="M67 9.30029H58.3L48.4 37.8003H56L57.4 33.0003C59.1 33.5003 60.9 33.8003 62.7 33.8003C64.5 33.8003 66.3 33.5003 68 33.0003L69.4 37.8003H77C76.9 37.8003 67 9.30029 67 9.30029ZM62.6 27.9003C61.3 27.9003 60.1 27.7003 59 27.4003L62.6 15.0003L66.2 27.4003C65.1 27.7003 63.9 27.9003 62.6 27.9003Z"
        fill="white"
      />
      <path
        d="M140.7 9.30029H132L122 37.8003H129.6L131 33.0003C132.7 33.5003 134.5 33.8003 136.3 33.8003C138.1 33.8003 139.9 33.5003 141.6 33.0003L143 37.8003H150.6L140.7 9.30029ZM136.3 27.9003C135 27.9003 133.8 27.7003 132.7 27.4003L136.3 15.0003L139.9 27.4003C138.8 27.7003 137.6 27.9003 136.3 27.9003Z"
        fill="white"
      />
      <path
        d="M242.7 9.30029H234L224.1 37.8003H231.7L233.1 33.0003C234.8 33.5003 236.6 33.8003 238.4 33.8003C240.2 33.8003 242 33.5003 243.7 33.0003L245.1 37.8003H252.7L242.7 9.30029ZM238.4 27.9003C237.1 27.9003 235.9 27.7003 234.8 27.4003L238.4 15.0003L242 27.4003C240.9 27.7003 239.6 27.9003 238.4 27.9003Z"
        fill="white"
      />
      <path
        d="M300.3 7.2002H313.1C319.3 7.2002 322.4 10.3002 322.4 15.2002C322.4 18.9002 320.7 21.2002 317.3 22.0002C321.8 22.7002 324 25.2002 324 29.5002C324 34.4002 320.7 37.7002 313.9 37.7002H300.4V7.2002H300.3ZM304.5 11.2002V20.3002H312.5C316.5 20.3002 318.1 18.5002 318.1 15.6002C318.1 12.6002 316.3 11.2002 312.5 11.2002H304.5ZM304.5 24.1002V33.6002H314C318 33.6002 319.8 32.2002 319.8 29.1002C319.8 25.8002 318.1 24.1002 313.9 24.1002H304.5Z"
        fill="white"
      />
      <path
        d="M335 37.9003C331.2 37.9003 328.8 36.1003 328.8 31.8003V4.80029H332.8V31.4003C332.8 33.5003 334.2 34.2003 335.9 34.2003C336.3 34.2003 336.6 34.2003 337.1 34.2003V37.8003C336.7 37.8003 336 37.9003 335 37.9003Z"
        fill="white"
      />
      <path
        d="M339.3 26.1001C339.3 19.1001 343.4 14.1001 350.4 14.1001C357.3 14.1001 361.4 19.2001 361.4 26.1001C361.4 33.0001 357.4 38.2001 350.4 38.2001C343.4 38.3001 339.3 33.1001 339.3 26.1001ZM343.2 26.1001C343.2 30.5001 345.4 34.5001 350.4 34.5001C355.3 34.5001 357.5 30.5001 357.5 26.1001C357.5 21.7001 355.4 17.8001 350.4 17.8001C345.4 17.8001 343.2 21.7001 343.2 26.1001Z"
        fill="white"
      />
      <path
        d="M381.7 33.6001C380.2 36.7001 377.4 38.3001 373.8 38.3001C367.7 38.3001 364.6 33.0001 364.6 26.2001C364.6 19.6001 367.8 14.1001 374.3 14.1001C377.7 14.1001 380.3 15.6001 381.7 18.7001V14.6001H385.6V35.8001C385.6 42.6001 382.4 47.2001 374.1 47.2001C370.2 47.2001 368.1 46.7001 365.8 45.9001V42.0001C368.4 42.8001 371 43.4001 373.9 43.4001C379.7 43.4001 381.7 40.3001 381.7 36.0001V33.6001ZM374.9 34.5001C378.5 34.5001 381.7 32.2001 381.7 27.1001V25.2001C381.7 20.0001 378.8 17.8001 375.4 17.8001C370.9 17.8001 368.6 20.8001 368.6 26.2001C368.5 31.7001 370.8 34.5001 374.9 34.5001Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_815_1117"
        x1="14.9161"
        y1="21.8055"
        x2="5.9611"
        y2="37.3155"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="0.923" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_815_1117">
        <rect width="386" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
